
const Modal = require('app/ui/Modal');

const InvoiceForm = require('app/restaurant/analyse/invoice/Form');

class CreateModal {
    defaultOptions() {
        return {
            'id': window.uniqid(),
            'title': "title",
            'analyse': null,

            'staticModal': true,
            'onSuccess': function(invoice){},
            'onClose': function(event){},
            'onShown': function(event){}
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.analyse = this.settings.analyse;
        if(!this.analyse.id){
            window.notify("Missing analyse object in ProductCreateModal","danger");
        }

        this.initialize();
    }

    initialize() {
        var self = this;

        this.onCloseModal = this.onCloseModal.bind(this);

        this.build();
    }

    build(){

        this.$content = $('<div/>')
        .addClass('restaurant-analyse-invoice-create-modal');

        this.modal = new Modal({
            'id': this.settings.id,
            'title': this.settings.title,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "xl",

            'onShown':this.settings.onShown,
            'onClose':this.onCloseModal,
        })

        this.$content
        .append(this.buildForm());

        this.modal.show();
        
        this.form.onDOMReady();
    }

    onCloseModal(event,modal){
        let doClose = true;
        if(this.form.hasUnsubmittedData() && !this.form.isBtnAddRequested()){
            doClose = confirm("Des données non enregistrées sont présentes, voulez-vous vraiment fermer la fenêtre ?");
        }

        if(doClose){
            if(this.settings.onClose){
                this.settings.onClose(event,modal);
            }
        }else{
            event.preventDefault();
            modal.show();
        }
    }

    buildForm(){
        var self = this;

        this.form = new InvoiceForm({
            'analyse': this.analyse,
            'success': function(data){
                self.onSuccess(data);
            },
            'modal': this.modal,
        });

        this.$form = this.form.getForm();

        return this.$form;
    }

    onSuccess(data){
        this.settings.onSuccess(data);
    }
}

module.exports = CreateModal;

